export default __webpack_public_path__ + "static/media/23.ceeb393e.png";